import { css, Stack, styled } from '@mui/material';

export const StepsContainer = styled(Stack)(
  () => css`
    background-color: transparent;
    justify-content: center;
    margin-top: 24px;
    flex-direction: row;
    gap: 8px;
  `,
);

type TStepProps = {
  active: boolean;
};

export const Step = styled('div')<TStepProps>(
  ({ theme, active }) => css`
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: ${theme.palette.primary[600]};
    opacity: ${active ? 1 : 0.1};
    cursor: pointer;
  `,
);
